import React, { useState } from "react";
import AssetDetailsPopup from "./AssetDetailsPopup";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";

const AssetActionButton = ({
  id,
  setEdit,
  setAssetId,
  toggleShowAddEditAsset,
  toggleShowDelete,
  used,
}) => {
  const [showView, setShowView] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"View"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleShowModal}
              icon={faEye}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
        <span>/</span>
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={() => {
                setEdit(true);
                toggleShowAddEditAsset();
                setAssetId(id);
              }}
            />
          </span>
        </CustomTooltip>
        {used ? (
          <></>
        ) : (
          <>
            <span>/</span>
            <CustomTooltip message={"Delete"}>
              <span>
                <FontAwesomeIcon
                  icon={faTrash}
                  size="1x"
                  onClick={() => {
                    setAssetId(id);
                    toggleShowDelete();
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
      </span>

      {showView && (
        <AssetDetailsPopup
          showView={showView}
          assetId={id}
          toggleShowModal={toggleShowModal}
          setShowView={setShowView}
        />
      )}
    </>
  );
};

export default AssetActionButton;
